import { TransactionStatus } from '../../types';
import React from 'react';
import transFINISHED from '../../images/icon-success.svg';
import transCANCELLED from '../../images/icon-error.svg';
import transINFO from '../../images/icon-info.svg';
import { FormattedMessage } from 'react-intl';
import { BusinessStatusEnum } from './BusinessStatusEnum';
import StatusContent from './StatusContent';
import ButtonSendVoucher from "../components/buttons/ButtonSendVoucher";
import StatusContentDefault from "./StatusContentDefault";

type Props = {
  transactionStatus: TransactionStatus;
};


const Status = ({ transactionStatus }: Props) => {

  const renderResult = () => {

    const normalizedTransactionStatus: BusinessStatusEnum =
        BusinessStatusEnum[transactionStatus.saleState] ??
      BusinessStatusEnum.NOT_FOUND;

    switch (normalizedTransactionStatus) {
      case BusinessStatusEnum.AUTHORIZED:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transINFO} className="icon-info" alt="transaction authorized"/>}
            labelType="authorized"
          />
        );
      case BusinessStatusEnum.ABANDONED:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transCANCELLED} className="icon-error" alt="transaction abandoned"/>}
            labelType="abandoned"
          />

        );
      case BusinessStatusEnum.ANTIFRAUD_REJECTED:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transCANCELLED} className="icon-error" alt="transaction antifraud-rejected"/>}
            labelType="antifraud-rejected"
          />
        );
      case BusinessStatusEnum.BANK_FRAUD_REJECTED:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transCANCELLED} className="icon-error" alt="transaction bank-fraud-rejected"/>}
            labelType="bank-fraud-rejected"
          />
        );
      case BusinessStatusEnum.BANK_REJECTED:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transCANCELLED} className="icon-error" alt="transaction bank-rejected"/>}
            labelType="bank-rejected"
          />
        );
      case BusinessStatusEnum.CANCELLED:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transCANCELLED} className="icon-error" alt="transaction cancelled"/>}
            labelType="cancelled"
          />
        );
      case BusinessStatusEnum.ERROR:
        return (
          <StatusContent
            normalizedTransactionStatus={normalizedTransactionStatus}
            icon={<img src={transCANCELLED} className="icon-error" alt="transaction error"/>}
            labelType="error"
          />
        );
      case BusinessStatusEnum.EXPIRED:
        if(transactionStatus.responseCode == 'EXPIRED_CARD'){
        return (
          <StatusContent
              normalizedTransactionStatus={normalizedTransactionStatus}
              icon={<img src={transCANCELLED} className="icon-error" alt="transaction expired"/>}
              labelType="expired-card"
          />
        );}
        else {
          return (
              <StatusContent
                  normalizedTransactionStatus={normalizedTransactionStatus}
                  icon={<img src={transCANCELLED} className="icon-error" alt="transaction expired"/>}
                  labelType="expired-transaction"
              />
          );}
      case BusinessStatusEnum.PLATFORM_REJECTED:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transCANCELLED} className="icon-error" alt="transaction platform-rejected"/>}
                labelType="platform-rejected"
            />
        );
      case BusinessStatusEnum.PAID:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transFINISHED} className="icon-success" alt="transaction paid"/>}
                labelType="paid"
            />
        );
      case BusinessStatusEnum.CHARGEBACK:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transCANCELLED} className="icon-error" alt="transaction chargeback"/>}
                labelType="chargeback"
            />
        );
      case BusinessStatusEnum.PENDING:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transINFO} className="icon-info" alt="transaction pending"/>}
                labelType="pending"
            />
        );
      case BusinessStatusEnum.REFUND:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transCANCELLED} className="icon-error" alt="transaction refund"/>}
                labelType="refund"
            />
        );
      case BusinessStatusEnum.IN_DISPUTE:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transINFO} className="icon-info" alt="transaction dispute"/>}
                labelType="in-dispute"
            />
        );
      case BusinessStatusEnum.PARTIAL_REFUND:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transINFO} className="icon-info" alt="transaction partial-refund"/>}
                labelType="partial-refund"
            />
        );
      case BusinessStatusEnum.THREEDS_REJECTED:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transCANCELLED} className="icon-error" alt="transaction threeds"/>}
                labelType="threeds-rejected"
            />
        );
      case BusinessStatusEnum.RETURNING:
        return (
            <StatusContent
                normalizedTransactionStatus={normalizedTransactionStatus}
                icon={<img src={transINFO} className="icon-info" alt="transaction returning"/>}
                labelType="returning"
            />
        );

      default:
        return (
          <StatusContentDefault
            orderStatus={transactionStatus.orderStatus}
            icon={<img src={transINFO} className="icon-info" alt="transaction not-found"/>}
            labelType="not-found"
          />
        );
    }
  };

  return (
      <div className="mainStatus">
        <div className="main-form-container">
          <div className="main-form-row">
            <div className="main-form-column">
              <div className="payment-trans-info">
                <FormattedMessage id="status.commercialName"/>
              </div>
            </div>
            <div className="main-form-column">
              <div className="payment-trans-info-sub">
                {transactionStatus.commercialName !== null ? transactionStatus.commercialName : '-'}
              </div>
            </div>
          </div>

          <div className="main-form-row">
            <div className="main-form-column">
              <div className="payment-trans-info">
                <FormattedMessage id="status.orderId"/>
              </div>

            </div>
            <div className="main-form-column">
              <div className="payment-trans-info-sub">
                {transactionStatus.orderId}
              </div>
            </div>
          </div>

          <div className="main-form-row">
            <div className="main-form-column">
              <div className="payment-trans-info">
                <FormattedMessage id="status.reference"/>
              </div>

            </div>
            <div className="main-form-column">
              <div className="payment-trans-info-sub">
                {transactionStatus.reference}
              </div>
            </div>
          </div>

          <div className="main-form-row">
            <div className="main-form-column">
              <div className="payment-trans-info">
                <FormattedMessage id="status.paymentMethod"/>
              </div>

            </div>
            <div className="main-form-column">
              <div className="payment-trans-info-sub">
                {transactionStatus.paymentMethodMain}
              </div>
            </div>


          </div>
        </div>

        {renderResult()}

        <div>
          {transactionStatus.sendEmailBuyer &&
              <ButtonSendVoucher className={"sendVoucherScenario"}
                                 transactionId={transactionStatus.id}
              />}
        </div>
      </div>
  );
};

export default Status;
